module.exports = __webpack_public_path__ + "img/estrella2.4f0873f9.png";